<template>
    <div class="cookies-page">
        <header class="cookies-hero">
            <div class="cookies-hero-content">
                <div class="hero-inner">
                    <h1 class="cookies-title">Utilisation des cookies</h1>
                </div>
            </div>
        </header>

        <main class="cookies-container">
            <section class="cookies-content">
                <div class="content-box">
                    <p class="cookies-paragraph">
                        Comme la quasi-totalite des sites internet, nous utilisons des cookies afin de vous fournir
                        un service web plus personnalise. Il nous serait impossible de mettre en oeuvre toutes les
                        fonctionnalites du site sans utiliser de cookies.
                    </p>

                    <h2 class="cookies-section-title">Qu'est-ce qu'un cookie ?</h2>
                    <p class="cookies-paragraph">
                        Un cookie est une chaine de caracteres contenant des informations que nous transferons sur le
                        disque dur de votre ordinateur, via votre navigateur internet, afin que le site puisse vous
                        reconnaitre.
                    </p>
                    <p class="cookies-paragraph">
                        Les cookies ne peuvent pas etre utilises pour vous identifier personnellement ou nominativement.
                    </p>
                    <p class="cookies-paragraph">
                        En regle generale, ceux-ci contiennent le nom du domaine dont le cookie est originaire, la
                        duree de vie du cookie et une valeur, qui est generalement un numero unique genere de maniere
                        aleatoire.
                    </p>
                    <p class="cookies-paragraph">
                        Nous utilisons aussi d'autres technologies comme des balises web, des balises pixel, des tags
                        ou des technologies similaires dans le meme but.
                    </p>

                    <h2 class="cookies-section-title">Comment utilisons-nous les cookies ?</h2>
                    <h3 class="cookies-subtitle">1ere categorie : les cookies de fonctionnalite</h3>
                    <p class="cookies-paragraph">
                        Ces cookies sont utilises par notre site pour certaines de ses fonctionnalites. Ils peuvent etre
                        utilises pour vous offrir une experience de navigation optimale lors de la consultation du site.
                    </p>
                    <p class="cookies-paragraph">
                        Par exemple, le cookie "mec_remember" nous permet de savoir si vous avez coche l'option
                        "Se souvenir de moi" pour vous connecter automatiquement le cas echeant.
                    </p>

                    <h3 class="cookies-subtitle">2e categorie : les cookies de performance</h3>
                    <p class="cookies-paragraph">
                        Ces cookies collectent des donnees anonymes sur la facon dont les gens utilisent le site.
                        Ces donnees sont fusionnees avec celles d'autres utilisateurs afin d'ameliorer le fonctionnement
                        du site.
                    </p>
                    <p class="cookies-paragraph">
                        Par exemple, nous utilisons Google Analytics pour nous aider a comprendre comment les
                        utilisateurs arrivent sur notre site et pour mettre en evidence les domaines ou nous pouvons
                        apporter des ameliorations. Les donnees stockees par ces cookies ne fournissent jamais de
                        renseignements personnels qui permettraient de reveler votre identite.
                    </p>

                    <h3 class="cookies-subtitle">3e categorie : les cookies de ciblage ou publicitaires</h3>
                    <p class="cookies-paragraph">
                        Ces cookies collectent des informations sur votre navigation afin de vous proposer un contenu
                        publicitaire pertinent et susceptible de vous interesser. Ils se souviennent des sites internet
                        que vous avez visites et partagent ces informations avec des tiers, tels que des annonceurs.
                    </p>
                    <p class="cookies-paragraph">
                        Par exemple, nous utilisons Google qui est un partenaire tiers pour vous proposer des publicites
                        personnalisees lorsque vous visitez d'autres sites.
                    </p>

                    <h2 class="cookies-section-title">Comment gerer mes cookies ?</h2>
                    <p class="cookies-paragraph">
                        Vous avez la possibilite de modifier les parametres de votre navigateur pour empecher le
                        stockage des cookies sur votre ordinateur ou votre appareil mobile sans votre consentement
                        explicite. La section d'aide de votre navigateur devrait vous fournir des details sur la facon
                        dont vous pouvez gerer les cookies. A noter que ce parametrage n'empechera pas l'affichage de
                        contenu publicitaire. Le contenu qui vous sera propose sera simplement moins pertinent.
                    </p>

                    <h2 class="cookies-section-title">Modifications de l'utilisation des cookies</h2>
                    <p class="cookies-paragraph">
                        Nous pouvons apporter des modifications a l'utilisation des cookies a tout moment. Si nous
                        apportons des modifications importantes a l'utilisation des cookies, nous tiendrons nos
                        utilisateurs informes lors de leur prochaine visite sur le site.
                    </p>
                    <p class="cookies-paragraph cookies-final">
                        Il est important d'etre au courant de l'utilisation des cookies. Si vous ne souhaitez pas
                        accepter la modification de l'Utilisation des Cookies, nous ne pourrons plus vous fournir notre
                        service et vous ne pourrez plus acceder a notre site.
                    </p>
                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.cookies,
.app-container.cookies main,
.app-container.cookies #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.cookies .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.cookies .footer-component {
    display: none !important;
}
</style>

<style scoped>
.cookies-page {
    background: #f6f9f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.cookies-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.cookies-hero-content {
    width: min(1400px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.cookies-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.cookies-container {
    width: min(1700px, 98vw);
    margin: 0 auto;
    padding: 54px 16px 28px;
    flex: 1;
}

.cookies-content {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    padding: 44px 52px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
}

.content-box {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.cookies-section-title {
    margin: 16px 0 0;
    font-size: 28px;
    line-height: 1.3;
    color: #1f3f2e;
}

.cookies-subtitle {
    margin: 8px 0 0;
    font-size: 21px;
    line-height: 1.35;
    color: #2d5016;
}

.cookies-paragraph {
    margin: 0;
    font-size: 18px;
    line-height: 1.8;
    color: #34463c;
    font-family: 'Heebo', 'Poppins', sans-serif;
}

.cookies-final {
    margin-top: 6px;
    font-weight: 500;
    color: #2d5016;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 1.5rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .cookies-hero {
        padding: 50px 20px 40px;
    }

    .cookies-title {
        font-size: 32px;
    }

    .cookies-container {
        padding: 34px 12px 28px;
    }

    .cookies-content {
        padding: 28px 24px;
    }

    .cookies-section-title {
        font-size: 24px;
    }

    .cookies-subtitle {
        font-size: 19px;
    }

    .cookies-paragraph {
        font-size: 16px;
        line-height: 1.7;
    }

    .footer-section {
        padding: 2rem 1rem 100px;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .cookies-hero {
        padding: 40px 20px 30px;
    }

    .cookies-title {
        font-size: 26px;
    }

    .cookies-container {
        padding: 24px 12px;
    }

    .cookies-content {
        padding: 20px 16px;
    }

    .cookies-section-title {
        font-size: 21px;
    }

    .cookies-subtitle {
        font-size: 17px;
    }

    .cookies-paragraph {
        font-size: 14px;
        line-height: 1.6;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'cookies',
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    methods: {
        onBackClick() {
            router.back();
        }
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
